export const WorkflowClipboardDataID = 'flowgram-workflow-clipboard-data';

export enum FlowCommandId {
  COPY = 'COPY',
  PASTE = 'PASTE',
  CUT = 'CUT',
  GROUP = 'GROUP',
  UNGROUP = 'UNGROUP',
  COLLAPSE = 'COLLAPSE',
  EXPAND = 'EXPAND',
  DELETE = 'DELETE',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT',
  RESET_ZOOM = 'RESET_ZOOM',
  SELECT_ALL = 'SELECT_ALL',
  CANCEL_SELECT = 'CANCEL_SELECT',
}
